var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-breadcrumb"},[_c('router-link',{attrs:{"tag":"a","to":{name: 'professionals'}}},[_c('img',{attrs:{"src":require("@/assets/img/voice/txt-breadcrumb.svg"),"alt":""}}),_c('p',[_vm._v("挑戦者たち 一覧へ戻る")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }